import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import mooda from "../../icons/mooda_logo_full.svg";
import { publicRequestSt } from "../../requestMethods";
const RedirectTinyTeeFashion = () => {
  const location = useLocation();
  const [error, setError] = useState();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const codeParam = queryParams.get("code");
    //log

    getOuth(codeParam);
  }, []);

  const getOuth = async (code) => {
    try {
      const res = await publicRequestSt.get(
        `/standard/tiny?slug=teefashion&code=${code}`,
      );
      setError(false);
    } catch (error) {
      setError(true);
    }
  };

  return (
    <div>
      <div
        style={{
          paddingTop: "80px",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          backgroundImage: "linear-gradient( to right, #FF3131, #FF914C )",
          height: "100vh",
        }}
      >
        <img
          style={{
            height: "100px",
          }}
          src={mooda}
        />
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",

          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "white",
          fontSize: "25px",
        }}
      >
        {!error ? (
          <p>
            A Mooda é a <strong>plataforma ideal</strong> para quem busca
            crescer no mercado de atacado, oferecendo uma variedade de recursos
            que{" "}
            <strong>
              facilitam a vida do atacadista e aumentam o faturamento da sua
              marca.
            </strong>
          </p>
        ) : (
          <p>
            Ocorreu um erro ao tentar conectar com o Tiny. Por favor, tente
            novamente mais tarde.
          </p>
        )}

        <p>
          <strong>Obrigado por escolher a Mooda!</strong>
        </p>
      </div>
    </div>
  );
};

export default RedirectTinyTeeFashion;
